export const apiRoot = process.env.VUE_APP_API_ROOT_URL;
export const warehouseRoot = process.env.VUE_APP_WAREHOUSE_ROOT_URL;
export const goApiRoot = process.env.VUE_APP_GO_API_ROOT_URL;
export const copilotRoot = process.env.VUE_APP_COPILOT_ROOT_URL;
export const syncfusionLicense = process.env.VUE_APP_SYNC_FUSION_LICENSE;
